module.exports = {
    'selectLanguage': 'Language',
    'menuNews': 'News',
};